"use client";
import { useTranslations } from "next-intl";
import { applyDataTestId } from "@/utils/testUtils";
import pom from "@/utils/pom";

import Link from "next/link";
import React from "react";
import ArrowLeftIcon from "@/components/_icons/arrowLeftIcon";

export const CustomerProfileHeader = ({}) => {
  const t = useTranslations("CustomerProfileHeader");
  return (
    <div
      data-testid={applyDataTestId(pom.customerProfile.customerProfileHeader)}
      className={[
        "flex",
        "flex-col",
        "items-center",
        "relative",
        "sm:sticky",
        "top-0",
        "z-20",
        "bg-white",
        "shadow-md",
      ].join(" ")}
    >
      <div
        className={[
          "flex",
          "flex-row",
          "px-10",
          "py-8",
          "w-full",
          "justify-between",
        ].join(" ")}
      >
        <Link href="/">
          <div
            className={["flex", "flex-row", "gap-3", "items-center"].join(" ")}
          >
            <ArrowLeftIcon />

            <p className="text-[20px] font-medium text-[#373737]">
              {t("account")}
            </p>
          </div>
        </Link>
      </div>
    </div>
  );
};
